import { CONFIGURABLE_PAGE_IDS } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';
import {
  getPageConfigurationElement,
  getPageConfigurationGroup,
} from '@bupa-monorepo/shared-frontend/utils';
import { IPageConfiguration } from '@bupa-monorepo/shared-types/page-configuration-types';
import { AxiosResponse } from 'axios';
import {
  PackageBlockConfiguration,
  PricingPageConfiguration,
} from '../types/pricing-types';

export const fetchPricingPageConfiguration = (
  pageConfigId: CONFIGURABLE_PAGE_IDS
): Promise<PricingPageConfiguration> => {
  return companyCreationAxiosInstance
    .get(`/v1/customer/configurablePages/${pageConfigId}/pageConfiguration`)
    .then(mapResult);
};

const mapResult = ({
  data,
}: AxiosResponse<IPageConfiguration>): PricingPageConfiguration => {
  return {
    header: {
      title:
        getPageConfigurationElement({
          pageConfiguration: data,
          sectionId: 'headerSection',
          groupId: 'header',
          elementId: 'title',
        })?.value ?? '',
      subtitle:
        getPageConfigurationElement({
          pageConfiguration: data,
          sectionId: 'headerSection',
          groupId: 'header',
          elementId: 'subtitle',
        })?.value ?? '',
    },
    basicPackage: mapPackage(data, 'basicPackageSection'),
    extendedPackage: mapPackage(data, 'extendedPackageSection'),
  };
};

const mapPackage = (
  pageConfiguration: IPageConfiguration,
  sectionId: string
): PackageBlockConfiguration => {
  return {
    title:
      getPageConfigurationElement({
        pageConfiguration,
        sectionId,
        groupId: 'title',
        elementId: 'title',
      })?.value ?? '',
    description:
      getPageConfigurationElement({
        pageConfiguration,
        sectionId,
        groupId: 'title',
        elementId: 'description',
      })?.value ?? '',
    bonuses: [
      getPageConfigurationGroup({
        pageConfiguration,
        sectionId,
        groupId: 'bonus1',
      })?.isVisible
        ? (getPageConfigurationElement({
            pageConfiguration,
            sectionId,
            groupId: 'bonus1',
            elementId: 'text',
          })?.value ?? '')
        : '',
      getPageConfigurationGroup({
        pageConfiguration,
        sectionId,
        groupId: 'bonus2',
      })?.isVisible
        ? (getPageConfigurationElement({
            pageConfiguration,
            sectionId,
            groupId: 'bonus2',
            elementId: 'text',
          })?.value ?? '')
        : '',
      getPageConfigurationGroup({
        pageConfiguration,
        sectionId,
        groupId: 'bonus3',
      })?.isVisible
        ? (getPageConfigurationElement({
            pageConfiguration,
            sectionId,
            groupId: 'bonus3',
            elementId: 'text',
          })?.value ?? '')
        : '',
      getPageConfigurationGroup({
        pageConfiguration,
        sectionId,
        groupId: 'bonus4',
      })?.isVisible
        ? (getPageConfigurationElement({
            pageConfiguration,
            sectionId,
            groupId: 'bonus4',
            elementId: 'text',
          })?.value ?? '')
        : '',
      getPageConfigurationGroup({
        pageConfiguration,
        sectionId,
        groupId: 'bonus5',
      })?.isVisible
        ? (getPageConfigurationElement({
            pageConfiguration,
            sectionId,
            groupId: 'bonus5',
            elementId: 'text',
          })?.value ?? '')
        : '',
    ].filter(Boolean),
    price:
      getPageConfigurationElement({
        pageConfiguration,
        sectionId,
        groupId: 'price',
        elementId: 'text',
      })?.value ?? '',
    priceComment:
      getPageConfigurationElement({
        pageConfiguration,
        sectionId,
        groupId: 'priceComment',
        elementId: 'text',
      })?.value ?? '',
    asteriskComment:
      getPageConfigurationElement({
        pageConfiguration,
        sectionId,
        groupId: 'asteriskComment',
        elementId: 'text',
      })?.value ?? '',
  };
};
